import PropTypes from 'prop-types';
import React from 'react';

import mark from '../../../../static/img/pipl_logo.svg';

// Values taken verbatim from the 2026 "Pipl Search Rebrand" design lockup:
//   gap:14 · mark height:18 · divider 1x22 (--line) · Search 12/.22em/600 (--brand)
// All proportions are scaled off `height` (the mark height) using the design's
// own 18px-base ratios so the lockup stays identical at any size.
const LIGHT = { mark: '#000000', line: '#D6E0E9', brand: '#3ba2ff' };
const DARK = { mark: '#FFFFFF', line: 'rgba(255,255,255,0.4)', brand: '#FFFFFF' };

const PiplSearchLogo = ({ height = 32, variant = 'light', className }) => {
  const t = variant === 'dark' ? DARK : LIGHT;
  return (
    <div
      className={className}
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: height * (14 / 18),
      }}
      role="img"
      aria-label="pipl Search"
    >
      <div
        style={{
          height,
          aspectRatio: '465.707 / 286.504',
          background: t.mark,
          WebkitMaskImage: `url(${mark})`,
          maskImage: `url(${mark})`,
          WebkitMaskRepeat: 'no-repeat',
          maskRepeat: 'no-repeat',
          WebkitMaskPosition: 'center',
          maskPosition: 'center',
          WebkitMaskSize: 'contain',
          maskSize: 'contain',
          flex: 'none',
        }}
      />
      <span style={{ width: 1, height: height * (22 / 18), background: t.line, display: 'block' }} />
      <span
        style={{
          fontFamily: "'Poppins', system-ui, -apple-system, 'Segoe UI', sans-serif",
          fontSize: height * (12 / 18),
          letterSpacing: '.22em',
          fontWeight: 600,
          color: t.brand,
          textTransform: 'uppercase',
          lineHeight: 1,
          whiteSpace: 'nowrap',
        }}
      >
        Search
      </span>
    </div>
  );
};

PiplSearchLogo.propTypes = {
  height: PropTypes.number,
  variant: PropTypes.oneOf(['light', 'dark']),
  className: PropTypes.string,
};

export default PiplSearchLogo;
